import gql from 'graphql-tag';

import ProductDataFragment from './ProductData.js';

export default gql`
  fragment ProductTeaserItemFragment on ProductTeaserItem {
    id
    type
    data {
      titleHtml
      product {
        ...ProductDataFragment
      }
    }
  }
  ${ProductDataFragment}
`;
